import { ProjectsRemoveTokensReducer } from './types';

export const projectsRemoveTokensReducer: ProjectsRemoveTokensReducer = (
  state
) => {
  return {
    ...state,
    projects: [],
  };
};
